/**
 * Representa um banco brasileiro registrado no Sistema de Pagamentos Brasileiro (SPB).
 * @hideconstructor
 */
export class Bank {
  /** Código ISPB — Identificador de Sistema de Pagamentos Brasileiro. */
  private _ispb: string;
  /** Nome reduzido do banco. */
  private _name: string;
  /** Código COMPE — Sistema de Compensação de Cheques e Outros Papéis. */
  private _code: number;
  /** Nome completo do banco. */
  private _fullName: string;

  protected constructor(
    ispb: string,
    name: string,
    code: number,
    fullName: string
  ) {
    this._ispb = ispb;
    this._name = name;
    this._code = code;
    this._fullName = fullName;
  }
  /** Código ISPB — Identificador de Sistema de Pagamentos Brasileiro. */
  get ispb() {
    return this._ispb;
  }
  /** Nome reduzido do banco. */
  get name() {
    return this._name;
  }
  /** Código COMPE do banco. */
  get code() {
    return this._code;
  }
  /** Nome completo do banco. */
  get fullName() {
    return this._fullName;
  }

  /**
   * Cria uma instância de Bank a partir de um objeto bruto retornado pela API.
   * @param raw Objeto com os campos ispb, name, code e fullName
   * @returns Instância de Bank com os campos mapeados
   */
  static from(raw: { ispb: string; name: string; code: number; fullName: string }): Bank {
    return new Bank(raw.ispb, raw.name, raw.code, raw.fullName);
  }

  /**
   * Retorna uma representação JSON do banco como string formatada.
   * @returns String com os campos ispb, name, code e fullName
   */
  toString(): string {
    return JSON.stringify(
      { ispb: this._ispb, name: this._name, code: this._code, fullName: this._fullName },
      null,
      2
    )
  }
}
